export class HomepageOrganisation {
  /**
   *
   */
  public g_id: number | null = null;

  /**
   *
   */
  public g_desc: string | null = null;

  /**
   *
   */
  public sxd_creationdate: Date = new Date();
}
